import { Model } from '../model/model.class';

export class Publisher extends Model {

    public publisherId: number;

    constructor(
        public name: String,
        public ratemodel: String,
        public contact: String,
        public maxVideoSize: number
    ) {super(); }
}



// WEBPACK FOOTER //
// ./src/app/model/publisher.class.ts